<div class="card">
  <div class="card-header flex-between">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="">Home</a></li>
      <li class="breadcrumb-item">
        <span class="nav-link" (click)="hideModel.emit()">Operator Kit Management</span>
      </li>
      <li class="breadcrumb-item active" aria-current="page">{{ kit }}</li>
    </ol>
    <div class="flex-start">
      <button-status
        [filter]="filters['kit']"
        title="Tag"
        [multiple]="true"
        [items]="statuses"
      ></button-status>
      <button
        type="button"
        (click)="submitForm()"
        class="btn btn-primary-soft mr-0"
      >
        Submit Changes
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="overview-section">
      <div class="overview-field cursor-pointer" (click)="filterByStatus('ALL')">
        <div class="lg-text">{{ overview['total'] }}</div>
        <div>Total</div>
      </div>
      <div class="overview-field cursor-pointer" (click)="filterByStatus('In Operation')">
        <div class="text-success lg-text">{{ overview['in_operation'] }}</div>
        <div class="text-success">In Operation</div>
      </div>
      <div class="overview-field cursor-pointer" (click)="filterByStatus('Out Of Operation')">
        <div class="text-danger lg-text">
          {{ overview['out_of_operation'] }}
        </div>
        <div class="text-danger">Out of Operation</div>
      </div>
      <div class="overview-field cursor-pointer" (click)="filterByStatus('OnCourse Test')">
        <div class="text-warning lg-text">
          {{ overview['oncourse_test'] }}
        </div>
        <div class="text-warning">OnCourse Test</div>
      </div>
      <div class="overview-field cursor-pointer" (click)="filterByStatus('OnCourse Spare')">
        <div class="text-info lg-text">{{ overview['oncourse_spare'] }}</div>
        <div class="text-info">OnCourse Spare</div>
      </div>
    </div>
    <table class="table table-striped w-100">
      <thead>
        <tr>
          <th scope="col" class="text-center">TSD Asset ID</th>
          <th scope="col" class="text-center">Serial Number</th>
          <th scope="col">DeviceID</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let kit of kitsData | KitFilter : filters['kit']['selected'];
            let i = index
          "
          [ngClass]="{'row-with-changes': pendingChanges[kit.SerialNumber]}"
        >
          <td class="text-center serial-number">{{ kit.TagID }}</td>
          <td class="text-center serial-number">{{ kit.SerialNumber }}</td>
          <td>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="kit.DeviceID"
              name="tagId-{{ i }}"
              readonly
              disabled
            />
          </td>
          <td class="status-cell flex-start">
            <ng-container *ngIf="!editingStatus[kit.SerialNumber]; else editStatusTemplate">
              <div class="status-label"
                [ngStyle]="{
                  'background-color': getSelectedOptionColor(kit.Status) + '33',
                  'border-color': getSelectedOptionBorderColor(kit.Status),
                  'color': getSelectedOptionBorderColor(kit.Status)
                }">
                {{ kit.Status }}
                <span *ngIf="pendingChanges[kit.SerialNumber]" class="unsaved-changes-pill">
                  Unsaved Changes
                </span>
              </div>
              <div class="edit-icon" (click)="toggleEditStatus(kit.SerialNumber, kit.Status)">
                <i class="fa fa-pencil"></i>
              </div>
            </ng-container>
            <ng-template #editStatusTemplate>
              <div class="status-edit-container">
                <select
                  class="form-control"
                  [(ngModel)]="kit.Status"
                  name="status-{{ i }}"
                  [ngStyle]="{
                    'background-color': getSelectedOptionColor(kit.Status),
                    'border-color': getSelectedOptionBorderColor(kit.Status),
                    'color': getTextColor(getSelectedOptionColor(kit.Status))
                  }"
                >
                  <!-- Only show the allowed options -->
                  <option
                    *ngFor="let status of operatorAllowedStatuses"
                    [value]="status"
                    [ngStyle]="{
                      'background-color': getSelectedOptionColor(status),
                      'border-color': getSelectedOptionBorderColor(status),
                      'color': getTextColor(getSelectedOptionColor(status))
                    }"
                  >
                    {{ status }}
                  </option>
                </select>
                <div class="action-icons">
                  <i class="fa fa-check-circle text-success confirm-icon"
                     (click)="confirmStatusChange(kit)"></i>
                  <i class="fa fa-times-circle text-danger cancel-icon"
                     (click)="cancelStatusChange(kit)"></i>
                </div>
              </div>
            </ng-template>
          </td>
        </tr>
        <tr
          *ngIf="
            kitsData.length > 0 &&
            (kitsData | KitFilter : filters['kit']['selected']).length == 0
          "
        >
          <td colspan="4" class="center">
            No tags found matching the applied filters. Please try a different
            filter.
          </td>
        </tr>
        <tr *ngIf="kitsData.length == 0">
          <td colspan="4" class="center">No tags found.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-device-history
  [showModal]="showHistoryModal"
  [SerialNumber]="selectedKit"
  (modalClose)="closeHistoryModal()"
></app-device-history>
